import { createProviderToken } from '@core/common-legacy';

import { NotificationData } from './notification-data';

export interface NotificationsEventMiddleware {
  onError: (message: NotificationData | string) => void;
}

export const {
  provide: provideNotificationsEventMiddleware,
  inject: injectNotificationsEventMiddleware,
} = createProviderToken<NotificationsEventMiddleware>('Notifications controller middleware')();
